define("StoreLocator.Tooltip.View.Extension", [
  "StoreLocator.Tooltip.View",

  "underscore",
  "Ames.StoreLocator2.StoreLocator2.Model",
  "StoreLocator.List.View",
  "ReferenceMap",
  "StoreLocator.Tooltip.View",
], function defineWizardView(
  StoreLocatorTooltipView,
  _,
  StoreLocator2Model,
  StoreLocatorListView,
  ReferenceMap,
  StoreLocatorTooltip
) {
  _.extend(StoreLocatorTooltipView.prototype, {
    initialize: _.wrap(
      StoreLocatorTooltipView.prototype.initialize,
      function (fn, options) {
        this.locatorModel = new StoreLocator2Model();
        this.isRentalTools = true;

        fn.apply(this, _.toArray(arguments).slice(1));
      }
    ),
    getContext: _.wrap(
      StoreLocatorTooltipView.prototype.getContext,
      function (fn) {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        this.storeHours = this.model.get("storeHours");
        if (this.storeHours) {
          context.storeHours = this.storeHours.split(",");
        }
        var isRentalTools =
          parseFloat(context.storeId) < 233 || parseFloat(context.storeId) > 239
            ? true
            : false;
        setTimeout(function () {
          if (!$(".icon-store-locator .store-locator-tooltip-image").length) {
            if (isRentalTools) {
              $(".icon-store-locator").append(
                '<img src="https://sandbox.all-wall.com/images/map-marker.png" alt="AMES Specialty Trades, Tools, & Services" class="store-locator-tooltip-image" />'
              );
            } else {
              $(".icon-store-locator").append(
                '<img src="https://sandbox.all-wall.com/images/location-icon-rental-franchise.gif" alt="AMES Specialty Trades, Tools, & Services" class="store-locator-tooltip-image" />'
              );
            }
          }
        }, 1000);
        return context;
      }
    ),
  });
  _.extend(StoreLocatorListView.prototype, {
    getContext: _.wrap(
      StoreLocatorListView.prototype.getContext,
      function (fn) {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        context.isRentalTools =
          parseFloat(context.storeId) < 233 || parseFloat(context.storeId) > 239
            ? true
            : false;
        return context;
      }
    ),
  });
  ReferenceMap.prototype.getTooltip = function getTooltip(model, index) {
    this.locatorModel = new StoreLocator2Model();
    var self = this;
    // if (!this.tooltip || this.tooltip.internalId != model.id) {
    //   this.locatorModel
    //     .fetch({ data: { locationId: model.id } })
    //     .done(function (resp) {
    //       var storeHours = resp.storeHours;
    //       $(".store-hours").remove();
    //       // use jquery to append the store hours
    //       $(".store-hours-container").append(
    //         '<div class="store-hours">' +
    //           storeHours.split(",").join("<br>") +
    //           "</div>"
    //       );
    //     });
    // }
    if (!this.tooltip) {
      this.tooltip = new StoreLocatorTooltip({
        model: model,
        index: index,
        storeHours: "",
      });
    } else {
      this.tooltip.index = index;
      this.tooltip.model = model;
    }
    return this.tooltip;
  };
});
